<template>
  <el-empty description="暂无结果"></el-empty>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      keyword: '',
      icpnumber: '津ICP备20004248号-1' // j-yy.cn
      // icpnumber: '津ICP备20004248号-2' // j-xd.cn
      // icpnumber: '津ICP备20004248号-3' // j-dl.cn
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search.vue